module.exports = __webpack_public_path__ + "img/reportes_actividades.8987ada2.jpeg";